export default __webpack_public_path__ + "static/media/045-exit.cab99a18.png";